import Drawer from '@mozaic-ds/freemarker/js/modules/_drawer.js';
class ReassuranceDrawer {
  constructor(config) {
    try {
      if (config === undefined || config === null) {
        throw new Error('Class ReassuranceDrawer needs config');
      }
      this.config = config;
      this.openButton = document.querySelector(`.${config.openButtonClass}`);
      this.drawerInstance = null;
      this.initDrawer();
    } catch (error) {
      throw new Error(`${error}`);
    }
  }
  open() {
    this.drawerInstance.open();
  }
  initDrawer() {
    this.drawerInstance = new Drawer({
      classContent: this.config.drawerClass
    });
    if (this.openButton) {
      this.openButton.addEventListener('click', event => {
        event.preventDefault();
        this.open();
      });
    }
  }
}
export default ReassuranceDrawer;